<tt-page>
    <tt-card *ngIf="!tabletSize.matches" class="col-xs-12 sp-0">
        <tt-button ttText="new_p2_table" ttTextAlign="left" ttIcon="fas fa-plus" (ttClick)="createTable($event)"></tt-button>
    </tt-card>

    <ng-container *ngIf="!tabletSize.matches || itemState !== 'p2tableedit'; else tabletEditor">
        <tt-list [ttData]="tables" (ttClick)="openTable($event.item, $event.event)"></tt-list>
    </ng-container>

    <ng-template #tabletEditor>
        <tt-divider ttRememberId="p2table_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="50">
                    <tt-card class="col-xs-12 p-5" ttHeading="h_p2tables">
                        <tt-button ttText="new_p2_table" ttTextAlign="left" ttIcon="fas fa-plus" (ttClick)="createTable($event)"></tt-button>
                    </tt-card>

                    <tt-list class="col-xs-12 p-5" [ttData]="tables" (ttClick)="openTable($event.item, $event.event)"></tt-list>
                </tt-divider-pane>

                <tt-divider-pane ttSize="50">
                    <tt-p2-table-edit *ngIf="p2TableKeyno !== ''" class="col-xs-12 p-5" [p2TableKeyno]="p2TableKeyno" [inline]="true" (onSave)="updateList()"></tt-p2-table-edit>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </ng-template>
</tt-page>
